<script lang="ts">
	/**
	 * Textarea field component. Allows custom text or a global text key to be set as label.
	 * To use this component, bind your variable to the value of this field.
	 *
	 * <Textarea bind:value={yourVariable} label="First name" />
	 * <Textarea bind:value={yourVariable} labelKey="first_name" placeholderKey="first_name" />
	 */
	import Text from '$lib/components/Text.svelte';
	import { page } from '$app/stores';

	interface Translation {
		isRichtext: boolean;
		text: string;
	}

	export let value: string; // Value of the textarea field
	export let id: string; // Id of the textarea field, needed for label
	export let name: string; // (Optional) Name of the inputfield

	export let label: string; // (Optional) Label Text
	export let labelKey: string | null = null; // (Optional) Global text key for label

	export let placeholder: string; // (Optional) Playerholder text
	export let placeholderKey: string | null = null; // (Optional) Global text key for placeholder

	let placeholderText: Translation | null = null;

	$: if (placeholderKey && placeholderKey in $page.data.globalTexts) {
		placeholderText = $page.data.globalTexts[placeholderKey];
	} else {
		placeholderText = {
			isRichtext: false,
			text: '[' + placeholderKey + ']'
		};
	}
</script>

<div>
	{#if label}
		<label for={id}>{label}</label>
	{/if}
	{#if labelKey}
		<label for={id}><Text key={labelKey} /></label>
	{/if}
	<textarea
		bind:value
		placeholder={placeholderKey ? placeholderText?.text : placeholder}
		{id}
		{name}
	/>
</div>

<style>
	label {
		display: block;
		margin: 0.5rem;
	}

	textarea {
		width: 100%;
		padding: 0.5rem;
		display: inline-block;
		border: 1px solid black;
		max-width: 800px;
	}
</style>
